import { render, staticRenderFns } from "./StrapItem.vue?vue&type=template&id=a460ad6e&scoped=true&"
import script from "./StrapItem.vue?vue&type=script&lang=js&"
export * from "./StrapItem.vue?vue&type=script&lang=js&"
import style0 from "./StrapItem.vue?vue&type=style&index=0&id=a460ad6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a460ad6e",
  null
  
)

export default component.exports